export default __webpack_public_path__ + "static/media/success.b4da5812.svg";